module.exports = "/_next/static/files/c14cdb86973316725df5d8fd352490d7.png";